// src/layouts/Layout.tsx
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { workImageSources } from "../data/workImageSources";
import { preloadImages } from "../utils/preloadImages";
import "../tailwind.css"; 
import { NAVBAR_HEIGHT_CLASSES, FOOTER_HEIGHT_CLASSES } from "../constants/layout";

export default function Layout() {
  useEffect(() => {
    preloadImages(workImageSources);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Navbar />
      <div className={`${NAVBAR_HEIGHT_CLASSES} w-full`} aria-hidden="true" />
      <main className="container mx-auto max-w-6xl px-4 py-0">
        <Outlet />
      </main>
      <div className={`${FOOTER_HEIGHT_CLASSES} w-full`} aria-hidden="true" />
      <Footer />
    </div>
  );
}
